import React, { memo } from 'react';
import block from 'bem-cn';
import isEqual from 'lodash.isequal';

import { ReactComponent as UserIcon } from 'shared/img/user-svg.svg'

import { PragmaticDGABlackJack } from 'components/slots/PragmaticDGA/hooks';

import './BlackJack.scss';

type BlackJackProps = PragmaticDGABlackJack;

const b = block('pragmatic-dga-black-jack');

export const BlackJack = memo(({
  seat1,
  seat2,
  seat3,
  seat4,
  seat5,
  seat6,
  seat7,
}: BlackJackProps) => (
  <div className={b()}>
    <div className={b('users')}>
      <UserIcon className={b('user-icon', { occupied: seat1 })} />
      <UserIcon className={b('user-icon', { occupied: seat2 })} />
      <UserIcon className={b('user-icon', { occupied: seat3 })} />
      <UserIcon className={b('user-icon', { occupied: seat4 })} />
      <UserIcon className={b('user-icon', { occupied: seat5 })} />
      <UserIcon className={b('user-icon', { occupied: seat6 })} />
      <UserIcon className={b('user-icon', { occupied: seat7 })} />
    </div>
  </div>
), isEqual)
